import { dataMember } from 'santee-dcts';
import { GridDetails } from '../../../sample-tracking/tracking-overview/interfaces/grid';
import { ContainerTransferData, ContainerData } from '../../interfaces/shipment-form-data';

export class FormField {
    public sequence: number;
    public key: string;
    public relatedFormFields: FormField[] = [];
    public subSequence: number;
    public groupName: string;
    public isActive: boolean;

    constructor(
        sequence: number, key: string, groupName?: string, subSeq?: number, activeField?: boolean) {
        this.sequence = sequence;
        this.key = key;
        this.subSequence = subSeq;
        this.groupName = groupName;
        this.isActive = activeField;
        this.relatedFormFields = [];
    }
}

export class AddressField {
    @dataMember()
    public companyName?: string;
    @dataMember()
    public departmentName?: string;
    @dataMember()
    public addressLineOne?: string;
    @dataMember()
    public addressLineTwo?: string;
    @dataMember()
    public city?: string;
    @dataMember()
    public state?: string;
    @dataMember()
    public zipCode?: string;
    @dataMember()
    public phone?: string;
    @dataMember()
    public countryName?: string;
    @dataMember()
    public countryID?: string;
    @dataMember()
    public countryCode?: string;
    @dataMember()
    public zcDistrCode?: string;
    @dataMember()
    public labSiteName?: string;
    @dataMember()
    public barcode?: string;
    @dataMember()
    public labSiteId?: number;
}

export class SiteShipmentCourierData {
    @dataMember()
    public barcode: string;
    @dataMember()
    public labSiteCourierId: number;
    @dataMember()
    public courierName: string;
    @dataMember()
    public lgxCourierId?: number;
    @dataMember()
    public isPreferred: boolean;
}

export class SiteShippingAddressFetchRequest {
    public containerBarcodeList: string[];
}

export class Country {
    @dataMember()
    public countryId: number;
    @dataMember()
    public countryName: string;

    public id?: number;

    public value?: string;
}

export interface ShipmentFormInfo {
    formValue?: any;
    barcodes?: string[];
    gridData?: GridDetails;
    transferData?: ContainerTransferData[];
    currentFocus?: boolean;
    containerData?: ContainerData[];
    containerCreationStartedOn?: string;
    shipmentId?: number;
}

export enum FormButtonType {
    'Save' = 1,
    'Next' = 2,
    'Cancel' = 3,
    'Edit' = 4,
}

export interface ContainerBarcodeInfo {
    barcodes?: string[];
    containerTransferData?: ContainerTransferData[];
    containerData?: ContainerData[];
}